<template>
    <b-row>
        <b-col>
            <tab-cash></tab-cash>
        </b-col>
    </b-row>
</template>

<script>
    import TabCash from './settings/crudCash'

    export default {
        components: {
          TabCash,
        },
        data: () => ({}),
    }
</script>
